export const GameCategoryConst = {
  ALL: "all",
  HOT: "hot",
  NEW: "new",
};
